import moment from 'moment';
import config from '~/config';

export const date = (data) => {
    if (!data) {
        return null;
    }
    return moment(data, config.formats.dates.api).format(config.formats.dates.frontend);
};
